import { useState, useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { useLocation, useNavigate } from 'react-router-dom';
import Radio from 'components/ui-components/Radio';
import RadioContainer from 'components/ui-components/RadioContainer';
import Button from 'components/ui-components/Button';
import CardTemplate from 'components/ui-templates/CardTemplate';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import LoadingSpinner from 'components/ui-components/loaders/LoadingSpinner';
import MetaHelmet from 'helpers/MetaHelmet';

const IdentityVerification = () => {
  const [clickedVerify, setClickedVerify] = useState(false);
  const [userSelection, setUserSelection] = useState({
    responses: { A1: '', A2: '', A3: '' },
  });
  const location = useLocation();
  const navigate = useNavigate();
  const questionData = location.state;

  const requestConfig = {
    url:
      clickedVerify && Object.values(userSelection.responses).every(Boolean)
        ? `/mycef/account`
        : null,
    data: userSelection,
    method: 'post',
    headers: {
      Accept: 'application/json',
    },
  };
  const { data, error, loading } = useHTTP(requestConfig);

  const submitVerificationQuestionnaire = e => {
    e.preventDefault();
    setClickedVerify(true);
  };

  const selectedOption = (index, radioValue) => {
    if (clickedVerify) {
      setClickedVerify(false);
    }
    setUserSelection(curState => ({
      responses: {
        ...curState.responses,
        [`A${[index + 1]}`]: `${radioValue + 1}`,
      },
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Always make sure top of the view shows when navigating between steps

    if (data?.state === 'created') {
      navigate('/mycef/account/new/registration-success');
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      navigate('/mycef/account/new/identity-verification-unsuccessful', {
        state: error.error.data.branch,
      });
    }
  }, [error]);

  return (
    <>
      <MetaHelmet />
      <CardTemplate
        title="Identity Verification"
        description="Please answer the following questions to verify your identity and complete your credit check">
        <form className="mb-0" onSubmit={submitVerificationQuestionnaire}>
          {questionData?.map(({ label, radioItems }, index) => (
            <InnerFormSection key={label}>
              <RadioContainer
                legend={`${index + 1}. ${label}`}
                groupName={label}>
                {radioItems?.map(
                  ({ id: radioId, label: radioLabel, value: radioValue }) => (
                    <Radio
                      key={radioLabel}
                      variant="basic"
                      id={radioId}
                      label={radioLabel}
                      className={
                        clickedVerify &&
                        !userSelection.responses[`A${index + 1}`]
                          ? 'cef-ui-radio--error'
                          : ''
                      }
                      onChange={() => selectedOption(index, radioValue)}
                    />
                  ),
                )}
              </RadioContainer>
              {clickedVerify && !userSelection.responses[`A${index + 1}`] && (
                <p className="mt-8 fs-14 tc-cef-red ff-body">
                  Please select an answer
                </p>
              )}
            </InnerFormSection>
          ))}

          <Button
            className="cef-btn cef-btn--feature cef-btn--xxl cef-btn--green mt-20 l-mt-40"
            type="submit"
            disabled={loading}>
            {loading ? <LoadingSpinner /> : 'Complete Verification'}
          </Button>
        </form>
      </CardTemplate>
    </>
  );
};

export default IdentityVerification;
